import { IBaseCard, IBaseT1Card } from "./base-card.interface";
import { IDashboardModel } from "./dashboard-model.interface";
import { isJobsBillingCard } from "./jobs-billing-card.interface";

/**
 * Returns true when a card should be treated as grouped with its family members
 * (for display, drag-and-drop, and save propagation).
 *
 * Precedence (specific beats general):
 *   - card.isSplit === true  => Taxpayer (never grouped)
 *   - card.isSplit === false => Family   (always grouped)
 *   - card.isSplit == null   => defer to dashboard.DisplayGroupedCards
 *
 * `SupportsMultiCard` is required: dashboards that don't support multi-card are never grouped.
 */
export function isCardGrouped(
    card: Pick<IBaseT1Card, "isSplit"> | undefined | null,
    dashboard: Pick<IDashboardModel, "DisplayGroupedCards" | "SupportsMultiCard"> | undefined | null,
): boolean {
    if (!dashboard?.SupportsMultiCard) return false;
    if (!card) return false;
    if (card.isSplit === true) return false;
    if (card.isSplit === false) return true;
    return !!dashboard.DisplayGroupedCards;
}

export function getCardStatusId(card: IBaseCard): string {
    if (isJobsBillingCard(card)) {
        return card.job?.statusId ?? "";
    } else {
        return card.return?.statusId ?? "";
    }
}
